(() => {
  angular
    .module('complianceFrameworkApp.complianceFramework')
    .controller('TopNavController', TopNavController);

  /* ngInject */
  function TopNavController($rootScope, $state, config, discussionService, authenticationService, sessionService) {
    const vm = this;

    vm.config = config;
    vm.hasProductRole = sessionService.hasProductRole;
    vm.impersonatedUser = null;
    vm.recentDiscussionsCount = 0;
    vm.user = null;
    vm.logOut = logOut;

    activate();

    angular.element('[data-toggle="popover"]').popover();

    vm.stateChangeObserver = $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, _) {
      activate();
      vm.impersonatedUser = null;
    });

    function activate() {
      getRecentDiscussionsCount();
      vm.user = sessionService.getUser();
      vm.impersonatedUser = sessionService.getImpersonatedUser();
    }

    function getRecentDiscussionsCount() {
      discussionService(sessionService.getAuthToken()).recentCount(response => {
        vm.recentDiscussionsCount = response.count;
      });
    }

    function logOut() {
      authenticationService(sessionService.getAuthToken()).logOut();
      sessionService.destroySession();
      $state.go('unauthenticated.login');
    }
  }
})();
